import React, { useMemo, useState } from 'react';
import AdminHub from '../admin/AdminHub';
import AssetHistory from '../admin/AssetHistory';
import '../admin/admin.css';
import '../admin/v12-admin.css';
import '../inventory/inventory.css';
import '../inventory/member-admin.css';
import './app-review-demo.css';

const DEMO_PROFILE = {
  id: 'demo-admin',
  full_name: 'Casey Morgan',
  email: 'casey.morgan@demoagency.example',
  agency: 'Demo Fire Agency',
  tenant_id: 'demo-fire-agency',
  role: 'Line Medic',
  member_kind: 'line_medic',
  is_admin: true,
  approved: true,
  disabled: false,
};

const now = '2026-09-06T19:00:00.000Z';
const earlier = '2026-08-22T18:00:00.000Z';
const returnedAt = '2026-08-27T20:30:00.000Z';

const DEMO_TRACKING_STATE = {
  schemaVersion: 1,
  assets: [
    { id: 'DEMO-LM-PACK-01', name: 'Line Medic Pack 01', category: 'Line Medic Pack', status: 'deployed', condition: 'ready', currentDeploymentId: 'demo-deploy-1', active: true, createdAt: earlier, updatedAt: now },
    { id: 'DEMO-LM-PACK-02', name: 'Line Medic Pack 02', category: 'Line Medic Pack', status: 'available', condition: 'ready', currentDeploymentId: null, active: true, createdAt: earlier, updatedAt: now },
    { id: 'DEMO-TRAUMA-01', name: 'Trauma Bag 01', category: 'Trauma Bag', status: 'deployed', condition: 'ready', currentDeploymentId: 'demo-deploy-1', active: true, createdAt: earlier, updatedAt: now },
    { id: 'DEMO-TRAUMA-02', name: 'Trauma Bag 02', category: 'Trauma Bag', status: 'available', condition: 'ready', currentDeploymentId: null, active: true, createdAt: earlier, updatedAt: now },
    { id: 'DEMO-O2-01', name: 'O2 Bag 01', category: 'O2 Bag', status: 'deployed', condition: 'ready', currentDeploymentId: 'demo-deploy-1', active: true, createdAt: earlier, updatedAt: now },
    { id: 'DEMO-O2-02', name: 'O2 Bag 02', category: 'O2 Bag', status: 'available', condition: 'ready', currentDeploymentId: null, active: true, createdAt: earlier, updatedAt: now },
    { id: 'DEMO-AED-01', name: 'AED 01', category: 'AED', status: 'deployed', condition: 'ready', currentDeploymentId: 'demo-deploy-1', active: true, createdAt: earlier, updatedAt: now },
    { id: 'DEMO-AED-02', name: 'AED 02', category: 'AED', status: 'available', condition: 'ready', currentDeploymentId: null, active: true, createdAt: earlier, updatedAt: now },
    { id: 'DEMO-RADIO-01', name: 'Radio Antenna 01', category: 'Radio Antenna', status: 'deployed', condition: 'ready', currentDeploymentId: 'demo-deploy-1', active: true, createdAt: earlier, updatedAt: now },
    { id: 'DEMO-RADIO-02', name: 'Radio Antenna 02', category: 'Radio Antenna', status: 'available', condition: 'ready', currentDeploymentId: null, active: true, createdAt: earlier, updatedAt: now },
    { id: 'DEMO-CLIP-01', name: 'Clipboard 01', category: 'Clipboard', status: 'deployed', condition: 'ready', currentDeploymentId: 'demo-deploy-1', active: true, createdAt: earlier, updatedAt: now },
    { id: 'DEMO-CLIP-02', name: 'Clipboard 02', category: 'Clipboard', status: 'available', condition: 'ready', currentDeploymentId: null, active: true, createdAt: earlier, updatedAt: now },
    { id: 'DEMO-COMBI-01', name: 'Combi Tool 01', category: 'Combi Tool', status: 'deployed', condition: 'ready', currentDeploymentId: 'demo-deploy-1', active: true, createdAt: earlier, updatedAt: now },
    { id: 'DEMO-COMBI-02', name: 'Combi Tool 02', category: 'Combi Tool', status: 'available', condition: 'ready', currentDeploymentId: null, active: true, createdAt: earlier, updatedAt: now },
    { id: 'DEMO-BLS-01', name: 'Line EMT BLS Pack 01', category: 'Line EMT BLS Pack', status: 'available', condition: 'ready', currentDeploymentId: null, active: true, createdAt: earlier, updatedAt: now },
  ],
  deployments: [
    {
      id: 'demo-deploy-1',
      person: 'Casey Morgan',
      incident: 'DEMO RIDGE FIRE',
      incidentOrderNumber: 'D-CA-000141',
      deploymentType: 'EMPF',
      startDate: '2026-09-02',
      status: 'active',
      assetIds: ['DEMO-LM-PACK-01', 'DEMO-TRAUMA-01', 'DEMO-O2-01', 'DEMO-AED-01', 'DEMO-RADIO-01', 'DEMO-CLIP-01', 'DEMO-COMBI-01'],
      createdAt: '2026-09-02T16:00:00.000Z',
      updatedAt: now,
    },
    {
      id: 'demo-deploy-old',
      person: 'Taylor Rivera',
      incident: 'DEMO PINES FIRE',
      incidentOrderNumber: 'D-CA-000122',
      deploymentType: 'EMPF',
      startDate: '2026-08-22',
      status: 'closed',
      assetIds: ['DEMO-LM-PACK-02', 'DEMO-AED-02'],
      createdAt: earlier,
      returnedAt,
      updatedAt: returnedAt,
    },
  ],
  events: [
    { id: 'evt-1', type: 'asset_checkout', assetId: 'DEMO-LM-PACK-01', assetName: 'Line Medic Pack 01', deploymentId: 'demo-deploy-1', actor: 'Casey Morgan', timestamp: '2026-09-02T16:05:00.000Z' },
    { id: 'evt-2', type: 'asset_checkout', assetId: 'DEMO-LM-PACK-02', assetName: 'Line Medic Pack 02', deploymentId: 'demo-deploy-old', actor: 'Taylor Rivera', timestamp: earlier },
    { id: 'evt-3', type: 'asset_return', assetId: 'DEMO-LM-PACK-02', assetName: 'Line Medic Pack 02', deploymentId: 'demo-deploy-old', actor: 'Taylor Rivera', timestamp: returnedAt, condition: 'ready', deployedTo: 'Taylor Rivera' },
    { id: 'evt-4', type: 'asset_checkout', assetId: 'DEMO-AED-02', assetName: 'AED 02', deploymentId: 'demo-deploy-old', actor: 'Taylor Rivera', timestamp: earlier },
    { id: 'evt-5', type: 'asset_return', assetId: 'DEMO-AED-02', assetName: 'AED 02', deploymentId: 'demo-deploy-old', actor: 'Taylor Rivera', timestamp: returnedAt, condition: 'ready', deployedTo: 'Taylor Rivera' },
  ],
  recentIncidents: ['DEMO RIDGE FIRE', 'DEMO PINES FIRE'],
};

const DEMO_MEMBERS = [
  { id: 'm1', full_name: 'Casey Morgan', email: 'casey.morgan@demoagency.example', role: 'Line Medic', approved: true, activated_at: '2026-01-10T12:00:00Z', is_admin: true, restock_approver: true, inventory_notify: true, disabled: false },
  { id: 'm2', full_name: 'Taylor Rivera', email: 'taylor.rivera@demoagency.example', role: 'Line Medic', approved: true, activated_at: '2026-02-10T12:00:00Z', is_admin: false, restock_approver: true, inventory_notify: false, disabled: false },
  { id: 'm3', full_name: 'Jordan Lee', email: 'jordan.lee@demoagency.example', role: 'Line EMT', approved: true, activated_at: null, is_admin: false, restock_approver: false, inventory_notify: true, disabled: false },
  { id: 'm4', full_name: 'Alex Harper', email: 'alex.harper@demoagency.example', role: 'Line Medic Trainee', approved: false, activated_at: null, is_admin: false, restock_approver: false, inventory_notify: false, disabled: false },
  { id: 'm5', full_name: 'Morgan Wells', email: 'morgan.wells@demoagency.example', role: 'Line Medic', approved: false, activated_at: null, is_admin: false, restock_approver: false, inventory_notify: false, disabled: true },
];

const DEMO_INVENTORY = [
  { recordId: 'i1', item: 'Fentanyl 50 mcg/mL', catalogId: 'ALS-040', setId: 'DEMO-LM-PACK-01', setName: 'Line Medic Pack 01', component: 'Medication', lotSerial: 'DEMO-FEN-27', expirationDate: '2027-05-31', returnedToLogistics: false },
  { recordId: 'i2', item: 'Ketamine 50 mg/mL', catalogId: 'ALS-041', setId: 'DEMO-LM-PACK-01', setName: 'Line Medic Pack 01', component: 'Medication', lotSerial: 'DEMO-KET-27', expirationDate: '2027-03-31', returnedToLogistics: false },
  { recordId: 'i3', item: 'Saline Flush', catalogId: 'ALS-110', setId: 'DEMO-TRAUMA-01', setName: 'Trauma Bag 01', component: 'IV / IO', lotSerial: 'DEMO-NS-26', expirationDate: '2026-12-31', returnedToLogistics: false },
  { recordId: 'i4', item: 'Tourniquet', catalogId: 'BLS-005', setId: 'DEMO-TRAUMA-01', setName: 'Trauma Bag 01', component: 'Bleeding', lotSerial: 'DEMO-TQ-01', expirationDate: '', returnedToLogistics: false },
];

const DEMO_HEALTH = {
  overall: 'operational',
  checkedAt: now,
  services: {
    tracking: { status: 'operational', detail: 'Tracking backend responded normally.', latencyMs: 118, revision: 'demo-revision', atomicRevision: true, assets: 15, checks: { read: true, authorization: true, concurrency: true } },
    inventory: { status: 'operational', detail: 'Inventory ledger and catalog are available.', latencyMs: 104, catalogItems: 63, inventoryRecords: 41, checks: { catalog: true, ledger: true, recallIndex: true } },
    supabase: { status: 'operational', detail: 'Demo member authorization checks are healthy.', latencyMs: 96, checks: { session: true, profile: true, adminRole: true } },
    email: { status: 'operational', detail: 'Restock notification configuration is present.', checks: { configuration: true } },
  },
};

function ReviewRibbon() {
  return (
    <div className="review-demo-banner review-demo-banner--compact" style={{ marginBottom: 16 }}>
      <strong>APPLE APP REVIEW DEMO · LINE MEDIC · DEMO FIRE AGENCY</strong>
      <p>All records in this environment are fictional and local to this review session. The controls below use the same production administrator layouts and interaction patterns without reading or modifying production records.</p>
    </div>
  );
}

function ReviewHeaderActions({ onHome, onExit, homeLabel = 'Admin Home' }) {
  return (
    <div className="admin-topbar-actions">
      {onHome && <button type="button" onClick={onHome}>{homeLabel}</button>}
      <button type="button" onClick={onExit}>Return to Sign In</button>
    </div>
  );
}

function DemoAttention({ onHome, onExit }) {
  return (
    <div className="admin-root">
      <header className="admin-topbar">
        <div><h1>Needs Attention</h1><p>Operational exceptions, open handoffs, active deployments, and approaching inventory expirations.</p></div>
        <ReviewHeaderActions onHome={onHome} onExit={onExit} />
      </header>
      <main className="admin-page">
        <ReviewRibbon />
        {exportNotice && <div className="review-demo-success" style={{ marginBottom: 12 }}>{exportNotice}</div>}
        <section className="admin-card">
          <div className="admin-section-head"><div><h2>Access Audit</h2><p>Filter fictional app and signed hardware activity, then export the current view.</p></div><button type="button" onClick={() => setExportNotice('Demo Door Access CSV exported locally. No production data was included.')}>Export CSV</button></div>
          <div className="v12-admin-grid">
            <label>Search<input value={query} onChange={event => setQuery(event.target.value)} placeholder="Member, request, method…" /></label>
            <label>Result<select value={resultFilter} onChange={event => setResultFilter(event.target.value)}><option value="all">All results</option><option value="success">Success</option><option value="denied">Denied</option></select></label>
            <label>Method<select value={methodFilter} onChange={event => setMethodFilter(event.target.value)}><option value="all">All methods</option><option value="bluetooth">Bluetooth</option><option value="other">Other</option></select></label>
            <label>From<input type="date" defaultValue="2026-09-01" /></label>
            <label>Through<input type="date" defaultValue="2026-09-28" /></label>
          </div>
          {filteredAppEvents.map((row,index) => <div className="review-demo-row" key={index}><div><strong>{row[0]} · {row[1]}</strong><small>{row[3]}</small></div><span className="review-demo-pill">{row[2]}</span></div>)}
        </section>
        <div className="admin-summary-grid">
          <div className="admin-stat"><span>Active Deployments</span><strong>1</strong></div>
          <div className="admin-stat"><span>Gear Exceptions</span><strong>1</strong></div>
          <div className="admin-stat"><span>Open Handoffs</span><strong>1</strong></div>
          <div className="admin-stat"><span>Expiring ≤ 90 Days</span><strong>2</strong></div>
        </div>
        <section className="admin-card">
          <div className="admin-section-head"><div><h2>Open Gear Handoffs</h2><p>Fictional pending custody transfers requiring completion.</p></div></div>
          <div className="review-demo-row"><div><strong>Taylor Rivera → Jordan Lee</strong><small>DEMO RIDGE FIRE · receiver confirmation pending</small></div><span className="review-demo-pill">Open</span></div>
        </section>
        <section className="admin-card">
          <div className="admin-section-head"><div><h2>Gear Exceptions</h2><p>Returned or available equipment that still needs logistics attention.</p></div></div>
          <div className="review-demo-row"><div><strong>O2 Bag 02</strong><small>DEMO-O2-02 · needs restock after return</small></div><span className="review-demo-pill">Review</span></div>
        </section>
        <section className="admin-card">
          <div className="admin-section-head"><div><h2>Expiration Watch</h2><p>Fictional inventory approaching expiration.</p></div></div>
          <div className="review-demo-row"><div><strong>Saline Flush</strong><small>Lot DEMO-NS-26 · Trauma Bag 01</small></div><span className="review-demo-pill">≤ 90 days</span></div>
          <div className="review-demo-row"><div><strong>Demo medication</strong><small>Lot DEMO-MED-26 · Line Medic Pack 02</small></div><span className="review-demo-pill">≤ 60 days</span></div>
        </section>
      </main>
    </div>
  );
}

function DemoDeploymentDashboard({ initialTab = 'live', onHome, onExit }) {
  const [tab, setTab] = useState(initialTab);
  const [editNotice, setEditNotice] = useState('');
  const active = DEMO_TRACKING_STATE.deployments.filter(item => item.status !== 'closed');
  const readyAssets = DEMO_TRACKING_STATE.assets.filter(item => item.status === 'available' && item.condition === 'ready');
  const attention = DEMO_TRACKING_STATE.assets.filter(item => ['needs_inventory', 'needs_restock', 'damaged'].includes(item.status));
  const oos = DEMO_TRACKING_STATE.assets.filter(item => item.status === 'out_of_service' || item.condition === 'out_of_service');
  const groups = useMemo(() => {
    const by = new Map();
    DEMO_TRACKING_STATE.assets.forEach(asset => {
      if (!by.has(asset.category)) by.set(asset.category, []);
      by.get(asset.category).push(asset);
    });
    return [...by.entries()];
  }, []);

  return (
    <div className="admin-root">
      <header className="admin-topbar">
        <div><h1>Deployment Dashboard</h1><p>Live Line Medic operations and season history · Synced</p></div>
        <ReviewHeaderActions onHome={onHome} onExit={onExit} />
      </header>
      <nav className="admin-tabs" aria-label="Deployment dashboard sections">
        <button type="button" className={tab === 'live' ? 'active' : ''} onClick={() => setTab('live')}>Live</button>
        <button type="button" className={tab === 'gear' ? 'active' : ''} onClick={() => setTab('gear')}>Gear</button>
        <button type="button" className={tab === 'history' ? 'active' : ''} onClick={() => setTab('history')}>Asset History</button>
        <button type="button" className={tab === 'reports' ? 'active' : ''} onClick={() => setTab('reports')}>Reports</button>
        <button type="button" className={tab === 'season' ? 'active' : ''} onClick={() => setTab('season')}>Season</button>
      </nav>
      <main className="admin-page">
        <ReviewRibbon />
        {editNotice && <div className="review-demo-success" style={{ marginBottom: 16 }}>{editNotice}</div>}

        {tab === 'live' && (
          <>
            <div className="admin-summary-grid">
              <div className="admin-stat"><span>Personnel Deployed</span><strong>{active.length}</strong></div>
              <div className="admin-stat"><span>EMPF Capacity</span><strong>1</strong></div>
              <div className="admin-stat"><span>EMTF Capacity</span><strong>1</strong></div>
              <div className="admin-stat"><span>Ready Gear</span><strong>{readyAssets.length}</strong></div>
              <div className="admin-stat"><span>Needs Attention</span><strong>{attention.length}</strong></div>
              <div className="admin-stat"><span>OOS</span><strong>{oos.length}</strong></div>
            </div>

            <div className="admin-two-column">
              <section className="admin-card">
                <div className="admin-section-head"><div><h2>Line Medic / EMPF Capacity</h2><p>Complete program EMPF deployments available right now. Asset numbers do not need to match; capacity uses whichever physical gear is ready.</p></div><div className="admin-day-pill">1 ready</div></div>
                {['Line Medic Pack', 'Trauma Bag', 'O2 Bag', 'AED', 'Radio Antenna', 'Clipboard', 'Combi Tool'].map(label => <div className="admin-table-row" key={label}><span><strong>{label}</strong><small>2 program assets in service</small></span><strong>1 ready</strong></div>)}
                <div className="admin-deployment-meta"><span>Capacity is limited by: Line Medic Pack, Trauma Bag, O2 Bag, AED</span></div>
              </section>
              <section className="admin-card">
                <div className="admin-section-head"><div><h2>Line EMT / EMTF Capacity</h2><p>Complete EMTF deployments available right now. EMTF requires the BLS Pack, O2 Bag, Radio Antenna, Clipboard, and Combi Tool — no Trauma Bag or AED.</p></div><div className="admin-day-pill">1 ready</div></div>
                {['Line EMT BLS Pack', 'O2 Bag', 'Radio Antenna', 'Clipboard', 'Combi Tool'].map(label => <div className="admin-table-row" key={label}><span><strong>{label}</strong><small>Program assets in service</small></span><strong>1 ready</strong></div>)}
                <div className="admin-deployment-meta"><span>Capacity is limited by: Line EMT BLS Pack</span></div>
              </section>
            </div>

            <section className="admin-card">
              <div className="admin-section-head"><div><h2>Active Deployments</h2><p>Live personnel, incidents, deployment age, gear, and reported consumption.</p></div></div>
              <div className="admin-deployment-list">
                {active.map(deployment => {
                  const assigned = deployment.assetIds.map(id => DEMO_TRACKING_STATE.assets.find(asset => asset.id === id)).filter(Boolean);
                  return (
                    <article className="admin-deployment-card" key={deployment.id}>
                      <div className="admin-deployment-title">
                        <div><strong>{deployment.person}</strong><span>{deployment.incident} · {deployment.incidentOrderNumber}</span></div>
                        <div className="admin-deployment-actions"><button type="button" className="admin-inline-action" onClick={() => setEditNotice('Demo gear assignment editor opened locally. No production deployment was changed.')}>Edit Gear</button><div className="admin-day-pill">Day 5</div></div>
                      </div>
                      <div className="admin-deployment-meta"><span>{deployment.deploymentType}</span><span>{assigned.length} physical assets</span><span>0 supplies reported used</span></div>
                      <div className="admin-gear-tags">{assigned.map(asset => <span key={asset.id}>{asset.name}</span>)}</div>
                    </article>
                  );
                })}
              </div>
            </section>
          </>
        )}

        {tab === 'gear' && (
          <section className="admin-card">
            <div className="admin-section-head"><div><h2>Gear Status</h2><p>Actual physical assets only. Legacy bundle records are hidden.</p></div></div>
            <div className="admin-gear-groups">
              {groups.map(([category, assets]) => (
                <section className="admin-gear-group" key={category}>
                  <h3>{category}</h3>
                  {assets.map(asset => (
                    <div className="admin-gear-row" key={asset.id}>
                      <div><strong>{asset.name}</strong><small>{asset.id}{asset.currentDeploymentId ? ' · Casey Morgan @ DEMO RIDGE FIRE' : ''}</small></div>
                      <span className={`admin-status admin-status-${asset.status === 'deployed' ? 'deployed' : 'available'}`}>{asset.status === 'deployed' ? 'deployed' : 'available'}</span>
                    </div>
                  ))}
                </section>
              ))}
            </div>
          </section>
        )}

        {tab === 'history' && <AssetHistory state={DEMO_TRACKING_STATE} />}

        {tab === 'reports' && (
          <section className="admin-card">
            <div className="admin-section-head"><div><h2>Deployment Closeout Reports</h2><p>Permanent deployment, accountable gear, supply use, return condition, and handoff history in one fictional report.</p></div></div>
            <article className="admin-deployment-card">
              <div className="admin-deployment-title">
                <div><strong>Taylor Rivera</strong><span>DEMO PINES FIRE · D-CA-000122</span></div>
                <div className="admin-deployment-actions">
                  <button type="button" className="admin-inline-action" onClick={() => setEditNotice('Demo closeout opened for Print / Save PDF. No production record was accessed.')}>Print / PDF</button>
                  <button type="button" className="admin-inline-action" onClick={() => setEditNotice('Demo closeout CSV exported locally.')}>CSV</button>
                </div>
              </div>
              <div className="admin-deployment-meta"><span>EMPF</span><span>Returned Aug 27, 2026</span><span>2 gear items</span><span>3 supplies used</span><span>1 handoff event</span></div>
              <div className="admin-gear-tags"><span>Line Medic Pack 02</span><span>AED 02</span></div>
            </article>
          </section>
        )}

        {tab === 'season' && (
          <>
            <section className="admin-card admin-season-head"><div className="admin-section-head"><div><h2>Fire Season</h2><p>Calculated from permanent deployment and tracking-event history.</p></div><label>Season<select defaultValue="2026"><option>2026</option></select></label></div></section>
            <div className="admin-summary-grid admin-season-summary">
              <div className="admin-stat"><span>Deployments</span><strong>7</strong></div>
              <div className="admin-stat"><span>Members Deployed</span><strong>4</strong></div>
              <div className="admin-stat"><span>Incidents</span><strong>5</strong></div>
              <div className="admin-stat"><span>Personnel-Days</span><strong>42</strong></div>
              <div className="admin-stat"><span>Avg Assignment</span><strong>6.0 d</strong></div>
              <div className="admin-stat"><span>Longest</span><strong>14 d</strong></div>
            </div>
            <div className="admin-two-column">
              <section className="admin-card"><h2>Deployment Types</h2><div className="admin-table-row"><span><strong>EMPF</strong><small>5 deployments</small></span><strong>5</strong></div><div className="admin-table-row"><span><strong>EMTF</strong><small>2 deployments</small></span><strong>2</strong></div></section>
              <section className="admin-card"><h2>Members</h2>{[['Casey Morgan',14],['Taylor Rivera',11],['Jordan Lee',9],['Alex Harper',8]].map(([name,days]) => <div className="admin-table-row" key={name}><span><strong>{name}</strong><small>Fictional review history</small></span><strong>{days} days</strong></div>)}</section>
            </div>
          </>
        )}
      </main>
    </div>
  );
}

function DemoMemberManagement({ onHome, onExit }) {
  const [members, setMembers] = useState(DEMO_MEMBERS);
  const [pending, setPending] = useState(null);
  const [message, setMessage] = useState('');
  const [form, setForm] = useState({ fullName: '', email: '', isAdmin: false });
  const counts = useMemo(() => ({
    pending: members.filter(item => !item.approved && !item.disabled).length,
    active: members.filter(item => item.approved && !item.disabled && item.activated_at).length,
    notActivated: members.filter(item => item.approved && !item.disabled && !item.activated_at).length,
    admins: members.filter(item => item.is_admin && item.approved && !item.disabled).length,
    restock: members.filter(item => item.restock_approver && item.approved && !item.disabled).length,
    inventory: members.filter(item => item.inventory_notify && item.approved && !item.disabled).length,
    disabled: members.filter(item => item.disabled).length,
  }), [members]);

  const patch = (id, values) => setMembers(current => current.map(member => member.id === id ? { ...member, ...values } : member));
  const confirmAccess = () => {
    if (!pending) return;
    const enabling = pending.action === 'enable';
    patch(pending.member.id, { approved: enabling, disabled: !enabling });
    setMessage(`${pending.member.full_name} ${enabling ? 're-enabled' : 'disabled'} successfully in the local App Review demo.`);
    setPending(null);
  };
  const addMember = event => {
    event.preventDefault();
    const name = form.fullName.trim();
    const email = form.email.trim();
    if (!name || !email) return;
    setMembers(current => [...current, { id: `demo-${Date.now()}`, full_name: name, email, role: 'Line Medic', approved: true, activated_at: null, is_admin: form.isAdmin, restock_approver: false, inventory_notify: false, disabled: false }]);
    setMessage(`${name} preloaded locally. No production account or email was created.`);
    setForm({ fullName: '', email: '', isAdmin: false });
  };

  return (
    <div className="admin-root">
      <header className="admin-topbar">
        <div><h1>Member Management</h1><p>Account approval, program-admin access, and notification roles</p></div>
        <ReviewHeaderActions onHome={onHome} onExit={onExit} />
      </header>
      <main className="admin-page">
        <ReviewRibbon />
        <section className="inventory-card inventory-member-admin">
          <div className="inventory-section-head"><div><h2>Member Management</h2><p>Preload the Line Medic roster, send branded member onboarding, track account activation, and manage program permissions.</p></div><button type="button" onClick={() => setMessage('Member list refreshed from local fictional review data.')}>Refresh</button></div>
          {message && <div className="inventory-member-success">{message}</div>}
          <form className="inventory-member-provision" onSubmit={addMember}>
            <div className="inventory-member-provision-head"><div><strong>Preload Member</strong><span>Approve a member before their first sign-in.</span></div></div>
            <label>Full name<input value={form.fullName} onChange={event => setForm(current => ({ ...current, fullName: event.target.value }))} placeholder="Demo Member" /></label>
            <label>Organization email<input value={form.email} onChange={event => setForm(current => ({ ...current, email: event.target.value }))} placeholder="demo.member@demoagency.example" /></label>
            <label className="inventory-member-role-toggle"><input type="checkbox" checked={form.isAdmin} onChange={event => setForm(current => ({ ...current, isAdmin: event.target.checked }))} /> Program Admin</label>
            <button type="submit" className="inventory-save">Add Member</button>
          </form>
          <div className="inventory-member-summary">
            <div><small>Active</small><strong>{counts.active}</strong></div><div><small>Not Activated</small><strong>{counts.notActivated}</strong></div><div><small>Pending</small><strong>{counts.pending}</strong></div><div><small>Admins</small><strong>{counts.admins}</strong></div><div><small>Restock Team</small><strong>{counts.restock}</strong></div><div><small>Inventory Team</small><strong>{counts.inventory}</strong></div><div><small>Disabled</small><strong>{counts.disabled}</strong></div>
          </div>
          {members.map(member => (
            <div className="inventory-member-row" key={member.id}>
              <div className="inventory-member-main"><div className="inventory-member-name-line"><strong>{member.full_name}</strong><span className={`inventory-member-pill ${member.disabled ? 'disabled' : member.approved ? 'approved' : 'pending'}`}>{member.disabled ? 'Disabled' : !member.approved ? 'Pending' : member.activated_at ? (member.is_admin ? 'Admin' : 'Active') : 'Not Activated'}</span>{member.id === 'm1' && <span className="inventory-member-pill self">You</span>}</div><span>{member.email}</span><small>{member.role} · Demo Fire Agency</small></div>
              <div className="inventory-row-actions">
                {!member.disabled && member.approved && <><button type="button" className={member.is_admin ? 'inventory-save' : ''} onClick={() => patch(member.id, { is_admin: !member.is_admin })}>Admin access: {member.is_admin ? 'On' : 'Off'}</button><button type="button" className={member.restock_approver ? 'inventory-save' : ''} onClick={() => patch(member.id, { restock_approver: !member.restock_approver })}>Restock emails: {member.restock_approver ? 'On' : 'Off'}</button><button type="button" className={member.inventory_notify ? 'inventory-save' : ''} onClick={() => patch(member.id, { inventory_notify: !member.inventory_notify })}>Inventory emails: {member.inventory_notify ? 'On' : 'Off'}</button></>}
                {member.disabled ? <button type="button" className="inventory-save" onClick={() => setPending({ member, action: 'enable' })}>Re-enable</button> : member.id !== 'm1' && <button type="button" className="inventory-danger-action" onClick={() => setPending({ member, action: 'disable' })}>Disable</button>}
              </div>
            </div>
          ))}
          {pending && <div className="inventory-confirm-backdrop" role="presentation" onMouseDown={event => { if (event.currentTarget === event.target) setPending(null); }}><div className="inventory-confirm-modal" role="dialog" aria-modal="true"><strong>{pending.action === 'disable' ? 'Disable member access?' : 'Re-enable member access?'}</strong><p className="inventory-muted">{pending.member.full_name}{pending.action === 'disable' ? ' will lose normal Line Medic access. Historical deployment, gear, inventory, and audit records are preserved.' : ' will regain the Line Medic features permitted by their assigned roles.'}</p><div className="inventory-row-actions"><button type="button" onClick={() => setPending(null)}>Cancel</button><button type="button" className={pending.action === 'disable' ? 'inventory-danger-action' : 'inventory-save'} onClick={confirmAccess}>{pending.action === 'disable' ? 'Yes, Disable Access' : 'Yes, Re-enable Access'}</button></div></div></div>}
        </section>
      </main>
    </div>
  );
}

function DemoInventoryAdmin({ onHome, onExit }) {
  const [section, setSection] = useState('scanner');
  const [message, setMessage] = useState('');
  return (
    <>
      <nav className="inventory-admin-switcher" aria-label="Private inventory sections">
        <button type="button" onClick={onHome}>Admin Home</button>
        <button type="button" className={section === 'scanner' ? 'active' : ''} onClick={() => setSection('scanner')}>Scanner</button>
        <button type="button" className={section === 'restock' ? 'active' : ''} onClick={() => setSection('restock')}>Restock Requests</button>
        <button type="button" className={section === 'preseason' ? 'active' : ''} onClick={() => setSection('preseason')}>Preseason</button>
        <button type="button" className={section === 'inventory' ? 'active' : ''} onClick={() => setSection('inventory')}>Seasonal Inventory</button>
        <button type="button" onClick={onExit}>Return to Sign In</button>
      </nav>
      <div className="inventory-root">
        <header className="inventory-topbar">
          <div><h1>{section === 'scanner' ? 'Line Medic Inventory Admin' : section === 'restock' ? 'Line Medic Restock Requests' : section === 'preseason' ? 'Line Medic Preseason Planner' : 'Line Medic Seasonal Inventory'}</h1><p>{section === 'scanner' ? 'Private inventory scanning and seasonal management' : section === 'restock' ? 'Return usage, approval, Logistics ordering, and restock status' : section === 'preseason' ? 'Program-wide readiness and stocking preparation' : 'Season closeout, counts, and readiness'}</p></div><span>Private admin</span>
        </header>
        <main className="inventory-page">
          <ReviewRibbon />
          {message && <div className="inventory-member-success">{message}</div>}
          {section === 'scanner' && <><section className="inventory-card"><div className="inventory-section-head"><div><h2>Physical Inventory Scanner</h2><p>Select a container, scan or search the catalog, and reconcile actual stock against the saved standard.</p></div><button type="button" onClick={() => setMessage('Demo inventory refreshed locally.')}>Refresh</button></div><label>Inventory target<select defaultValue="DEMO-LM-PACK-01"><option value="DEMO-LM-PACK-01">Line Medic Pack 01</option><option value="DEMO-TRAUMA-01">Trauma Bag 01</option></select></label><label>Scan barcode or search item<input placeholder="Scan GS1 / barcode or search catalog" onChange={() => {}} /></label></section><div className="inventory-member-summary"><div><small>Applicable Items</small><strong>63</strong></div><div><small>Ready</small><strong>61</strong></div><div><small>Needs Count</small><strong>2</strong></div><div><small>Expired</small><strong>0</strong></div></div><section className="inventory-card">{DEMO_INVENTORY.map(row => <div className="inventory-member-row" key={row.recordId}><div className="inventory-member-main"><strong>{row.item}</strong><span>{row.catalogId} · {row.component}</span><small>Lot {row.lotSerial || 'N/A'} · Exp {row.expirationDate || 'N/A'}</small></div><span className="inventory-member-pill approved">Ready</span></div>)}</section></>}
          {section === 'restock' && <section className="inventory-card"><div className="inventory-section-head"><div><h2>Open Restock Requests</h2><p>Return usage awaiting approval, Logistics ordering, or completion.</p></div></div>{[['DEMO-RS-001','Casey Morgan','Line Medic Pack 01','2 items','Awaiting approval'],['DEMO-RS-002','Taylor Rivera','Trauma Bag 01','1 item','Ordered']].map(row => <div className="inventory-member-row" key={row[0]}><div className="inventory-member-main"><strong>{row[0]} · {row[1]}</strong><span>{row[2]} · {row[3]}</span></div><span className="inventory-member-pill pending">{row[4]}</span></div>)}</section>}
          {section === 'preseason' && <><div className="inventory-member-summary"><div><small>Program Containers</small><strong>9</strong></div><div><small>Ready</small><strong>8</strong></div><div><small>Needs Work</small><strong>1</strong></div></div><section className="inventory-card"><h2>Preseason Readiness</h2><p>Fictional review data mirrors the production planner without changing live inventory.</p>{['Line Medic Pack 01','Line Medic Pack 02','Trauma Bag 01','O2 Bag 01','AED 01'].map((name,index) => <div className="inventory-member-row" key={name}><div className="inventory-member-main"><strong>{name}</strong><small>{index === 1 ? '1 item needs review' : 'Saved standard complete'}</small></div><span className={`inventory-member-pill ${index === 1 ? 'pending' : 'approved'}`}>{index === 1 ? 'Review' : 'Ready'}</span></div>)}</section></>}
          {section === 'inventory' && <section className="inventory-card"><div className="inventory-section-head"><div><h2>Seasonal Inventory</h2><p>Closeout counts, archived stock, and next-season readiness.</p></div></div>{DEMO_INVENTORY.map(row => <div className="inventory-member-row" key={row.recordId}><div className="inventory-member-main"><strong>{row.item}</strong><span>{row.setName}</span><small>{row.catalogId} · {row.lotSerial || 'No lot'}</small></div><span className="inventory-member-pill approved">Active</span></div>)}</section>}
        </main>
      </div>
    </>
  );
}

function DemoTagSetup({ onHome, onExit }) {
  const [asset, setAsset] = useState('DEMO-LM-PACK-01');
  const [message, setMessage] = useState('');
  const url = `https://sacmetrolinemedic.app/gear/${asset}`;
  return (
    <div className="admin-root asset-tag-setup-root">
      <header className="admin-topbar"><div><h1>QR / NFC Tag Setup</h1><p>Registered physical asset identities, permanent recovery links, QR generation, and NFC programming</p></div><ReviewHeaderActions onHome={onHome} onExit={onExit} /></header>
      <main className="admin-page"><ReviewRibbon /><section className="admin-card"><div className="admin-section-head"><div><h2>Registered Asset Tags</h2><p>Select a category and asset exactly as you would in production. Review actions below remain local.</p></div></div><label>Category<select defaultValue="Line Medic Pack"><option>Line Medic Pack</option><option>Trauma Bag</option><option>O2 Bag</option><option>AED</option></select></label><label>Asset<select value={asset} onChange={event => setAsset(event.target.value)}><option value="DEMO-LM-PACK-01">Line Medic Pack 01 · DEMO-LM-PACK-01</option><option value="DEMO-LM-PACK-02">Line Medic Pack 02 · DEMO-LM-PACK-02</option></select></label></section><section className="admin-card"><div className="admin-hub-kicker">NFC PROGRAMMING · DEMO FIRE AGENCY</div><h2>Program a physical NFC tag</h2><p>Production uses the same canonical gear URL, Write NFC Tag, and Verify NFC Tag workflow. App Review simulates the hardware result.</p><div style={{ padding: 14, borderRadius: 12, background: 'rgba(255,255,255,.06)', fontFamily: 'monospace', overflowWrap: 'anywhere' }}>{url}</div><div className="inventory-row-actions" style={{ marginTop: 16 }}><button type="button" className="inventory-save" onClick={() => setMessage(`✓ Programmed ${asset} and completed automatic read-back verification locally.`)}>Write NFC Tag</button><button type="button" onClick={() => setMessage(`✓ Verified — demo tag is ${asset}.`)}>Verify NFC Tag</button></div>{message && <div className="inventory-member-success" style={{ marginTop: 16 }}>{message}</div>}</section></main>
    </div>
  );
}

function DemoRecall({ onHome, onExit }) {
  const [query, setQuery] = useState('DEMO-FEN-27');
  const [includeArchived, setIncludeArchived] = useState(false);
  const matches = useMemo(() => DEMO_INVENTORY.filter(record => {
    const q = query.trim().toLowerCase();
    if (!q) return false;
    return [record.item, record.catalogId, record.setId, record.setName, record.component, record.lotSerial, record.expirationDate].join(' ').toLowerCase().includes(q)
      && (includeArchived || !record.returnedToLogistics);
  }), [query, includeArchived]);
  const containers = new Set(matches.map(row => row.setId)).size;
  const products = new Set(matches.map(row => row.catalogId)).size;
  return (
    <div className="admin-root">
      <header className="admin-topbar"><div><h1>Lot / Recall Lookup</h1><p>Find every active physical unit by lot, product, catalog ID, GTIN/barcode, expiration, or container.</p></div><ReviewHeaderActions onHome={onHome} onExit={onExit} /></header>
      <main className="admin-page"><ReviewRibbon /><section className="admin-card"><div className="admin-section-head"><div><h2>Search inventory ledger</h2><p>Paste a lot number or barcode value from an EMS recall notice to see exactly where matching stock is located.</p></div></div><label>Lot, GTIN, product, catalog ID, expiration, or container<input value={query} onChange={event => setQuery(event.target.value)} placeholder="DEMO-FEN-27, Fentanyl, ALS-040…" autoFocus /></label><label style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 12 }}><input type="checkbox" checked={includeArchived} onChange={event => setIncludeArchived(event.target.checked)} />Include removed / archived inventory history</label></section>{query.trim() && <><div className="admin-summary-grid"><div className="admin-stat"><span>Active Units</span><strong>{matches.length}</strong></div><div className="admin-stat"><span>Containers</span><strong>{containers}</strong></div><div className="admin-stat"><span>Products</span><strong>{products}</strong></div></div><section className="admin-card"><div className="admin-section-head"><div><h2>Matches</h2><p>{matches.length ? 'Active stock is listed first. Archived history is clearly marked.' : 'No matching inventory was found.'}</p></div><div className="admin-day-pill">{matches.length} records</div></div>{matches.map(record => <div className="admin-table-row" key={record.recordId}><span><strong>{record.item}</strong><small>{record.setName} · {record.component} · {record.catalogId}</small><small>Lot {record.lotSerial || 'N/A'} · Exp {record.expirationDate || 'N/A'}</small></span><strong>{record.returnedToLogistics ? 'ARCHIVED' : 'ACTIVE'}</strong></div>)}{!matches.length && <div className="admin-empty">No match for “{query.trim()}”.</div>}</section></>}</main>
    </div>
  );
}

function DemoSystemHealth({ onHome, onExit }) {
  const [checkedAt, setCheckedAt] = useState(DEMO_HEALTH.checkedAt);
  const labels = { tracking: 'Tracking Backend', inventory: 'Inventory Backend', supabase: 'Member / Supabase', email: 'Restock Email' };
  return (
    <div className="admin-root">
      <header className="admin-topbar"><div><h1>System Health</h1><p>Live backend, inventory, member access, concurrency, and restock configuration checks</p></div><div className="admin-topbar-actions"><button type="button" onClick={() => setCheckedAt(new Date().toISOString())}>Refresh</button><button type="button" onClick={onHome}>Admin</button><button type="button" onClick={onExit}>Return to Sign In</button></div></header>
      <main className="admin-page"><ReviewRibbon /><section className="admin-card"><div className="admin-section-head"><div><h2>Overall</h2><p>Last checked {new Date(checkedAt).toLocaleString()}</p></div><span style={{ border: '1px solid rgba(74,222,128,.42)', borderRadius: 999, padding: '6px 10px', fontSize: 11, fontWeight: 800, color: '#86efac', background: 'rgba(34,197,94,.13)' }}>Operational</span></div></section><div className="admin-two-column">{Object.entries(DEMO_HEALTH.services).map(([name, service]) => <section className="admin-card" style={{ margin: 0 }} key={name}><div className="admin-section-head"><div><h2>{labels[name]}</h2><p>{service.detail}</p></div><span style={{ border: '1px solid rgba(74,222,128,.42)', borderRadius: 999, padding: '6px 10px', fontSize: 11, fontWeight: 800, color: '#86efac', background: 'rgba(34,197,94,.13)' }}>Operational</span></div><div className="admin-deployment-meta" style={{ marginBottom: 0 }}>{Number.isFinite(service.latencyMs) && <span>Latency: {service.latencyMs} ms</span>}{service.revision && <span>Revision: {service.revision}</span>}{service.atomicRevision !== undefined && <span>Atomic protection: {service.atomicRevision ? 'ACTIVE' : 'NOT DETECTED'}</span>}{Number.isFinite(service.assets) && <span>Assets: {service.assets}</span>}{Number.isFinite(service.catalogItems) && <span>Catalog items: {service.catalogItems}</span>}{Number.isFinite(service.inventoryRecords) && <span>Inventory records: {service.inventoryRecords}</span>}</div>{service.checks && <div style={{ display: 'grid', gap: 7, marginTop: 14 }}>{Object.entries(service.checks).map(([key, ok]) => <div key={key} className="admin-table-row" style={{ padding: '7px 0' }}><span><strong>{key}</strong></span><span className="inventory-member-pill approved">{ok ? 'Operational' : 'Warning'}</span></div>)}</div>}</section>)}</div></main>
    </div>
  );
}


const INITIAL_DEMO_FEED = [
  {
    id: 'demo-feed-1',
    title: '1.4 App Review Program Update',
    body: 'This fictional Program Feed post demonstrates targeted member messaging, acknowledgments, comments, and the same administrator workflow used in Line Medic.',
    priority: 'important',
    audience: 'All Line Medics',
    acknowledgment_required: true,
    comments_enabled: true,
    published_at: '2026-09-22T15:00:00Z',
  },
  {
    id: 'demo-feed-2',
    title: 'Demo field cache update',
    body: 'Radio cache and field-reference content were refreshed for this fictional review environment.',
    priority: 'normal',
    audience: 'Currently Deployed',
    acknowledgment_required: false,
    comments_enabled: false,
    published_at: '2026-09-21T18:30:00Z',
  },
];

const INITIAL_DEMO_BURNS = [
  {
    id: 'demo-burn-draft',
    name: 'Demo Training Burn',
    burn_date: '2026-10-03',
    start_time: '08:00',
    location: 'Demo Training Site',
    status: 'draft',
    requirements: ['2 × Line Medic', '1 × Line EMT'],
    volunteers: ['Taylor Rivera', 'Jordan Lee'],
  },
  {
    id: 'demo-burn-open',
    name: 'Demo Prescribed Burn',
    burn_date: '2026-10-10',
    start_time: '07:00',
    location: 'Demo Preserve',
    status: 'open_for_signup',
    requirements: ['1 × Line Medic'],
    volunteers: ['Casey Morgan', 'Taylor Rivera'],
  },
];

function DemoProgramFeedAdmin({ onHome, onExit }) {
  const [posts, setPosts] = useState(INITIAL_DEMO_FEED);
  const [message, setMessage] = useState('');
  const [title, setTitle] = useState('Demo program update');
  const [body, setBody] = useState('Fictional App Review message showing the same publish controls as production.');
  const [priority, setPriority] = useState('normal');
  const [audience, setAudience] = useState('all_line_medics');
  const [comments, setComments] = useState(true);
  const [ack, setAck] = useState(false);
  const [attachmentName, setAttachmentName] = useState('Demo-Operations-Map.pdf');

  const publish = event => {
    event.preventDefault();
    const nextTitle = title.trim();
    const nextBody = body.trim();
    if (!nextTitle || !nextBody) return;
    setPosts(current => [{
      id: 'demo-feed-' + Date.now(),
      title: nextTitle,
      body: nextBody,
      priority,
      audience: audience === 'all_line_medics' ? 'All Line Medics' : audience === 'currently_deployed' ? 'Currently Deployed' : 'Specific Members',
      acknowledgment_required: ack,
      comments_enabled: comments,
      attachments: attachmentName ? [{ name: attachmentName, type: 'PDF' }] : [],
      published_at: new Date().toISOString(),
    }, ...current]);
    setMessage('Demo Program Feed post published locally. Push/SMS delivery was simulated and no production member was contacted.');
  };

  const archive = id => {
    setPosts(current => current.filter(post => post.id !== id));
    setMessage('Demo Program Feed post archived locally. No production record was changed.');
  };

  return (
    <div className="admin-root">
      <header className="admin-topbar">
        <div><h1>Program Feed</h1><p>Publish member communications, acknowledgments, comments, and notification delivery.</p></div>
        <ReviewHeaderActions onHome={onHome} onExit={onExit} />
      </header>
      <main className="admin-page">
        <ReviewRibbon />
        {message && <div className="v12-success" style={{ marginBottom: 12 }}>{message}</div>}
        <section className="admin-card">
          <div className="admin-section-head"><div><h2>Create Program Feed Post</h2><p>Mirrors the production 1.4 workflow while every action remains fictional and local.</p></div></div>
          <form className="v12-admin-form" onSubmit={publish}>
            <label>Title<input value={title} onChange={event => setTitle(event.target.value)} /></label>
            <label>Message<textarea value={body} onChange={event => setBody(event.target.value)} /></label>
            <div className="v12-admin-note program-feed-attachment-editor">
              <strong>Attachments</strong><br />
              <span>Fictional local App Review file · production 1.4 supports protected photos and PDFs.</span>
              <div style={{ marginTop: 8 }}><button type="button" onClick={() => setAttachmentName(value => value ? '' : 'Demo-Operations-Map.pdf')}>{attachmentName ? `PDF · ${attachmentName} · Remove` : 'Add Demo PDF'}</button></div>
            </div>
            <div className="v12-admin-grid">
              <label>Priority<select value={priority} onChange={event => setPriority(event.target.value)}><option value="normal">Normal</option><option value="important">Important</option><option value="urgent">Urgent</option></select></label>
              <label>Audience<select value={audience} onChange={event => setAudience(event.target.value)}><option value="all_line_medics">All Line Medics</option><option value="specific_members">Specific Members</option><option value="currently_deployed">Currently Deployed</option></select></label>
            </div>
            <label><input type="checkbox" checked={comments} onChange={event => setComments(event.target.checked)} /> Allow comments</label>
            <label><input type="checkbox" checked={ack} onChange={event => setAck(event.target.checked)} /> Require acknowledgment</label>
            <div className="v12-check-row"><button type="submit" className="v12-primary">Publish Demo Post</button></div>
          </form>
        </section>
        <section className="admin-card" style={{ marginTop: 16 }}>
          <div className="admin-section-head"><div><h2>Published Posts</h2><p>Fictional member communication history for the review session.</p></div></div>
          {posts.map(post => (
            <div className="v12-admin-list-row" key={post.id}>
              <div><strong>{post.title}</strong><small>{post.priority === 'important' ? 'Important' : post.priority === 'urgent' ? 'Urgent' : 'Normal'} · {post.audience} · Fictional</small><span>{post.acknowledgment_required ? 'Acknowledgment required · ' : ''}{post.comments_enabled ? 'Comments enabled' : 'Comments off'}{post.attachments?.length ? ` · ${post.attachments.length} attachment(s)` : ''} · Read 2/4</span></div>
              <div><button type="button" onClick={() => archive(post.id)}>Archive</button></div>
            </div>
          ))}
        </section>
      </main>
    </div>
  );
}

function DemoPrescribedBurnsAdmin({ onHome, onExit }) {
  const [burns, setBurns] = useState(INITIAL_DEMO_BURNS);
  const [message, setMessage] = useState('');

  const transition = (id, status) => {
    setBurns(current => current.map(burn => burn.id === id ? { ...burn, status } : burn));
    setMessage('Demo burn moved to ' + status.replaceAll('_', ' ') + '. This lifecycle change is local to App Review.');
  };

  return (
    <div className="admin-root">
      <header className="admin-topbar">
        <div><h1>Prescribed Burns</h1><p>Create opportunities, collect volunteers, select rosters, notify members, and archive completed burns.</p></div>
        <ReviewHeaderActions onHome={onHome} onExit={onExit} />
      </header>
      <main className="admin-page">
        <ReviewRibbon />
        {message && <div className="v12-success" style={{ marginBottom: 12 }}>{message}</div>}
        <section className="admin-card">
          <div className="admin-section-head"><div><h2>Burn Opportunities</h2><p>The buttons below mirror the production lifecycle without sending real notifications.</p></div></div>
          {burns.map(burn => (
            <div className="v12-admin-list-row" key={burn.id}>
              <div>
                <strong>{burn.name}</strong>
                <small>{burn.burn_date} · {burn.start_time} · {burn.location}</small>
                <span><strong>{burn.status.replaceAll('_', ' ')}</strong> · {burn.requirements.join(' · ')}</span>
                <span>Volunteers: {burn.volunteers.join(', ')}</span>
              </div>
              <div>
                {burn.status === 'draft' && <button type="button" className="v12-primary" onClick={() => transition(burn.id, 'open_for_signup')}>Open Signup</button>}
                {burn.status === 'open_for_signup' && <button type="button" className="v12-primary" onClick={() => transition(burn.id, 'signup_closed')}>Close Signup</button>}
                {burn.status === 'signup_closed' && <button type="button" className="v12-primary" onClick={() => transition(burn.id, 'roster_selected')}>Finalize Roster + Notify Selected</button>}
                {burn.status === 'roster_selected' && <button type="button" className="v12-primary" onClick={() => transition(burn.id, 'completed')}>Mark Completed</button>}
                {burn.status === 'completed' && <button type="button" onClick={() => transition(burn.id, 'archived')}>Archive</button>}
                {burn.status === 'archived' && <span className="review-demo-pill">Archived</span>}
              </div>
            </div>
          ))}
        </section>
      </main>
    </div>
  );
}

function DemoDoorAccessAudit({ onBack, onHome, onExit }) {
  const [refreshedAt, setRefreshedAt] = useState('2026-09-23T20:52:00.000Z');
  const [query, setQuery] = useState('');
  const [resultFilter, setResultFilter] = useState('all');
  const [methodFilter, setMethodFilter] = useState('all');
  const [exportNotice, setExportNotice] = useState('');
  const appEvents = [
    ['Casey Morgan', 'Bluetooth unlock', 'Success', 'Face ID + short-lived GuestKey'],
    ['Taylor Rivera', 'Bluetooth unlock', 'Success', 'Verified member session'],
    ['Jordan Lee', 'Unlock request', 'Denied', 'Demo account disabled for Door Access'],
  ];
  const hardwareEvents = [
    ['Bridge Online', 'Connected to igloohome', '8:49 PM'],
    ['Bridge Battery Reading', 'Battery 92%', '8:50 PM'],
    ['Bluetooth Unlock', 'Hardware log 11', '8:51 PM'],
    ['Auto-Lock After Close', 'Door closed · mechanism locked', '8:52 PM'],
  ];
  const filteredAppEvents = appEvents.filter(row => {
    const search = query.trim().toLowerCase();
    const matchesSearch = !search || row.join(' ').toLowerCase().includes(search);
    const matchesResult = resultFilter === 'all' || row[2].toLowerCase() === resultFilter;
    const method = row[1].toLowerCase().includes('bluetooth') ? 'bluetooth' : 'other';
    const matchesMethod = methodFilter === 'all' || method === methodFilter;
    return matchesSearch && matchesResult && matchesMethod;
  });

  return (
    <div className="admin-root">
      <header className="admin-topbar">
        <div><h1>Door Access Audit</h1><p>Member unlock history plus signed igloohome lock and Bridge telemetry.</p></div>
        <div className="admin-topbar-actions">
          <button type="button" onClick={() => setRefreshedAt(new Date().toISOString())}>Refresh Telemetry</button>
          {onBack && <button type="button" onClick={onBack}>Notification Audit</button>}
          <button type="button" onClick={onHome}>Admin Home</button>
          <button type="button" onClick={onExit}>Return to Sign In</button>
        </div>
      </header>
      <main className="admin-page">
        <ReviewRibbon />
        <div className="admin-summary-grid">
          <div className="admin-stat"><span>Bridge</span><strong>Online</strong></div>
          <div className="admin-stat"><span>Lock Battery</span><strong>92%</strong></div>
          <div className="admin-stat"><span>Last Sync</span><strong>8:52 PM</strong></div>
          <div className="admin-stat"><span>Signed Events</span><strong>{hardwareEvents.length}</strong></div>
        </div>

        <div className="admin-two-column">
          <section className="admin-card">
            <div className="admin-section-head"><div><h2>igloohome Bridge Status</h2><p>Fictional 1.4 telemetry mirrors the read-only production Door Access diagnostics.</p></div><span className="inventory-member-pill approved">Connected</span></div>
            <div className="admin-table-row"><span><strong>Bridge visibility</strong><small>Demo Bridge · connected to igloohome</small></span><strong>Visible</strong></div>
            <div className="admin-table-row"><span><strong>Lock telemetry</strong><small>Battery 92% · last sync 8:52 PM</small></span><strong>Current</strong></div>
            <div className="admin-table-row"><span><strong>Signed webhook stream</strong><small>Provider signature verified before event ingestion</small></span><strong>Healthy</strong></div>
            <div className="admin-deployment-meta"><span>Refreshed {new Date(refreshedAt).toLocaleString()}</span></div>
          </section>

          <section className="admin-card">
            <div className="admin-section-head"><div><h2>Application Audit</h2><p>Who requested Door Access and how the app handled the request.</p></div></div>
            {filteredAppEvents.map((row,index) => <div className="review-demo-row" key={index}><div><strong>{row[0]} · {row[1]}</strong><small>{row[3]}</small></div><span className="review-demo-pill">{row[2]}</span></div>)}
          </section>
        </div>

        <section className="admin-card">
          <div className="admin-section-head"><div><h2>Signed Hardware Activity</h2><p>Lock-origin and Bridge events are shown separately from app unlock requests.</p></div><span className="admin-day-pill">{hardwareEvents.length} events</span></div>
          {hardwareEvents.map((row,index) => <div className="review-demo-row" key={index}><div><strong>{row[0]}</strong><small>{row[1]}</small></div><span className="review-demo-pill">{row[2]}</span></div>)}
        </section>
      </main>
    </div>
  );
}

function DemoNotificationAudit({ onHome, onExit }) {
  const [view, setView] = useState('notifications');
  const rows = [
    ['Program Feed', 'Casey Morgan', 'APNs', 'Provider accepted', 'Push queued from demo-feed-1'],
    ['Prescribed Burn', 'Taylor Rivera', 'APNs', 'Provider accepted', 'Selected-roster notification'],
    ['Program Feed', 'Jordan Lee', 'SMS', 'Opted out / skipped', 'Optional SMS disabled'],
    ['Prescribed Burn', 'Alex Harper', 'APNs', 'No token', 'Member has no registered push token'],
  ];

  if (view === 'door') return <DemoDoorAccessAudit onBack={() => setView('notifications')} onHome={onHome} onExit={onExit} />;

  return (
    <div className="admin-root">
      <header className="admin-topbar">
        <div><h1>Operational Audit</h1><p>APNs, optional SMS, and Gear Room access audit without overstating provider acceptance as delivery or read.</p></div>
        <div className="admin-topbar-actions">
          <button type="button" onClick={() => setView('door')}>Door Access Audit</button>
          <button type="button" onClick={onHome}>Admin Home</button>
          <button type="button" onClick={onExit}>Return to Sign In</button>
        </div>
      </header>
      <main className="admin-page">
        <ReviewRibbon />
        <section className="admin-card">
          <div className="admin-section-head"><div><h2>Recent Notification Events</h2><p>Fictional 1.4 audit records only; no provider or production member data is queried.</p></div></div>
          {rows.map((row,index) => (
            <div className="review-demo-row" key={index}>
              <div><strong>{row[0]} · {row[1]}</strong><small>{row[2]} · {row[4]}</small></div>
              <span className="review-demo-pill">{row[3]}</span>
            </div>
          ))}
        </section>
      </main>
    </div>
  );
}

export default function MacAppReviewDemo() {
  const [route, setRoute] = useState('/admin');
  const exit = () => window.location.assign('/');
  const home = () => setRoute('/admin');
  const navigate = path => setRoute(path);

  if (route === '/admin/attention') return <DemoAttention onHome={home} onExit={exit} />;
  if (route === '/admin/program-feed') return <DemoProgramFeedAdmin onHome={home} onExit={exit} />;
  if (route === '/admin/prescribed-burns') return <DemoPrescribedBurnsAdmin onHome={home} onExit={exit} />;
  if (route === '/admin/notifications') return <DemoNotificationAudit onHome={home} onExit={exit} />;
  if (route === '/admin/door-access') return <DemoDoorAccessAudit onHome={home} onExit={exit} />;
  if (route.startsWith('/admin/deployments')) {
    const tab = new URL(`https://demo.invalid${route}`).searchParams.get('tab') || 'live';
    return <DemoDeploymentDashboard initialTab={tab} onHome={home} onExit={exit} />;
  }
  if (route === '/inventory-admin') return <DemoInventoryAdmin onHome={home} onExit={exit} />;
  if (route === '/admin/members') return <DemoMemberManagement onHome={home} onExit={exit} />;
  if (route === '/admin/tags') return <DemoTagSetup onHome={home} onExit={exit} />;
  if (route === '/admin/recall') return <DemoRecall onHome={home} onExit={exit} />;
  if (route === '/admin/health') return <DemoSystemHealth onHome={home} onExit={exit} />;

  return (
    <>
      <div className="admin-root"><main className="admin-page" style={{ paddingBottom: 0 }}><ReviewRibbon /></main></div>
      <AdminHub
        profile={DEMO_PROFILE}
        onNavigate={navigate}
        onMemberDashboard={exit}
        headerExtra={<span className="admin-day-pill">Demo Fire Agency</span>}
      />
    </>
  );
}
